import React, { createContext, PropsWithChildren, useContext } from 'react'
import { BrowserRouter, useInRouterContext } from 'react-router-dom'

const FeatureBasenameContext = createContext('')

export const CoreContextBrowserRouter: React.FC<PropsWithChildren<{ basename: string }>> = ({ basename, children }) => {
  const hasCoreRouterContext = useInRouterContext()
  const content = (
    <FeatureBasenameContext.Provider value={hasCoreRouterContext ? basename.replace(/\/+$/, '') : ''}>
      {children}
    </FeatureBasenameContext.Provider>
  )

  return hasCoreRouterContext ? content : <BrowserRouter basename={basename}>{content}</BrowserRouter>
}

export const useFeatureBasename = () => useContext(FeatureBasenameContext)
